module.exports = __webpack_public_path__ + "img/charging-hub-realized.d4cd6b5e.svg";